// extracted by mini-css-extract-plugin
export var blue = "_42-g";
export var brand = "_42-c";
export var darkGrey = "_42-f";
export var disabled = "_42-6";
export var disabledSubtle = "_42-7";
export var error = "_42-8";
export var green = "_42-h";
export var grey = "_42-e";
export var icon = "_42-0";
export var inherit = "_42-b";
export var lightGrey = "_42-d";
export var orange = "_42-j";
export var pink = "_42-l";
export var primary = "_42-1";
export var purple = "_42-m";
export var quaternary = "_42-4";
export var quinary = "_42-5";
export var red = "_42-k";
export var secondary = "_42-2";
export var success = "_42-a";
export var tertiary = "_42-3";
export var warning = "_42-9";
export var white = "_42-n";
export var yellow = "_42-i";